import { render, staticRenderFns } from "./mvHctrPayment.vue?vue&type=template&id=48be978d"
import script from "./mvHctrPayment.vue?vue&type=script&lang=js"
export * from "./mvHctrPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports